var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imagesProps)?_c('div',{staticClass:"use-cases-image"},[_c('pict',{staticClass:"use-cases-image__image",attrs:{"block-name":"use-cases-image","default":_vm.imagesProps.default,"sources":_vm.imagesProps.sources}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }